import * as Yup from "yup";
import React from "react";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  PersonRoleType,
  PersonSex,
  PersonType,
  UserRoleEnum,
  TipoBollettaRecapito
} from "../../../helpers/enums";
import { getValidationRule, TranslatedText, getStandardAddressFormat } from "../../../helpers/helpers";
import moment from "moment";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";

// Custom steps
// Questi sono gli step renderizzati ad-hoc e chiamati usando layout[].component
// Ogni componente custom riceve come props fields e layout
const InfoLabel = ({ label = "Test label" }) => {
  return (<div className="info-label" style={{ display: "flex", alignItems: "center", marginBottom: "4rem" }}>
    <span className="gc-icon-functional-attention-2-col">
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
    <p style={{ marginLeft: "10px" }}>
      {label}
    </p>
  </div>)
}
const ListItem = ({ text }) => {
  return <p className="list-item">
    {text}
  </p>
}

// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi
const model = {
  formId: CaseForms.DenunciaPerdite,
  formField: {
    selezioneContratto: {
      name: "selezioneContratto",
      label: <TranslatedText i18nKey="cases.contract-select.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.contract-select.select-contract" />
      ),
      loading: <TranslatedText i18nKey="cases.contract-select.loading" />,
      noContractFound: (
        <TranslatedText i18nKey="cases.contract-select.no-contract-found" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "active-contract-select",
      excludeStatusTypes: ['inactive'],
      onSelected: (selected, values, setFieldValue, setFieldTouched, profile) => {
        setFieldValue("comune", selected.city);
        setFieldValue("via", `${selected.street} ${selected.streetNumber}`);
        setFieldTouched("comune", false);
        setFieldTouched("via", false);
        
       
      },
    },
    comune: {
      name: "comune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      disabled: true,
    },
    via: {
      name: "via",
      label: <TranslatedText i18nKey="cases.request_info.fields.via.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      disabled: true,
    },
    // step 1.2
    tipoIntestatario: {
      name: "tipoIntestatario",
      label: <TranslatedText i18nKey="cases.tipoIntestatario.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "switch-radio",
      options: [
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.NATURAL" />,
          value: PersonType.NATURAL,
          grid: { xs: 12, md: "auto" },
        },
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.LEGAL" />,
          value: PersonType.LEGAL,
          grid: { xs: 12, md: 3 },
        },
      ],
      onSelected: (selected, values, profile, setFieldValue) => {
        if (profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
          let piva = "";
          let fiscalCode = "";
          if (profile.fiscalCode !== "") {
            if (isNaN(Number(profile.fiscalCode))) {
              fiscalCode = profile.fiscalCode;
            } else {
              piva = profile.fiscalCode;
            }
          }
          if (selected === PersonType.NATURAL) {
            values[name.name] === "" &&
              setFieldValue(name.name, profile.name || "");
            values[surname.name] === "" &&
              setFieldValue(surname.name, profile.surname || "");
            values[fisicaCodiceFiscale.name] === "" &&
              setFieldValue(fisicaCodiceFiscale.name, fiscalCode || "");
          }
          if (selected === PersonType.LEGAL) {
            values[giuridicaRagioneSociale.name] === "" &&
              setFieldValue(
                giuridicaRagioneSociale.name,
                profile.businessName || ""
              );
            values[giuridicaCodiceFiscale.name] === "" &&
              setFieldValue(giuridicaCodiceFiscale.name, fiscalCode || "");
            values[giuridicaPartitaIVA.name] === "" &&
              setFieldValue(giuridicaPartitaIVA.name, piva || "");
            values[giuridicaPartitaIVA2.name] === "" &&
            setFieldValue(giuridicaPartitaIVA2.name, piva || "");
            values[giuridicaRappresentanteLegaleName.name] === "" &&
              setFieldValue(
                giuridicaRappresentanteLegaleName.name,
                profile.businessName || ""
              );
            values[giuridicaSedeLegaleComune.name] === "" &&
              setFieldValue(
                giuridicaSedeLegaleComune.name,
                profile.legalAddress_city || ""
              );
            values[giuridicaProvincia.name] === "" &&
              setFieldValue(
                giuridicaProvincia.name,
                profile.legalAddress_province || ""
              );
            values[giuridicaCAP.name] === "" &&
              setFieldValue(
                giuridicaCAP.name,
                profile.legalAddress_postalCode || ""
              );
            values[giuridicaSedeLegaleIndirizzo.name] === "" &&
              setFieldValue(
                giuridicaSedeLegaleIndirizzo.name,
                `${profile.legalAddress_street} ${profile.legalAddress_streetNumber}`
              );
            
          }
          values[bollettaEsistenteCellulare.name] === '' && 
              setFieldValue(
                 bollettaEsistenteCellulare.name, profile.mobilePhoneNumber || '');
            values[bollettaEsistenteEmail.name] === '' && 
              setFieldValue(bollettaEsistenteEmail.name, profile.email || '');
        
        }
      },
    },
    fisicaSesso: {
      name: "fisicaSesso",
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      label: <TranslatedText i18nKey="cases.gender" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "radio",
      options: [
        {
          label: PersonSex.M,
          value: PersonSex.M,
          grid: { xs: 12, md: "auto" },
        },
        {
          label: PersonSex.F,
          value: PersonSex.F,
          grid: { xs: 12, md: 3 },
        },
      ],
    },
    name: {
      name: "name",
      label: <TranslatedText i18nKey="cases.request_info.fields.name.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    surname: {
      name: "surname",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.surname.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaCodiceFiscale: {
      name: "fisicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.invalid" />
      ),
      type: "input",
      uppercase: true,
    },
    fisicaNatoA: {
      name: "fisicaNatoA",
      label: <TranslatedText i18nKey="cases.request_info.fields.natoA.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaDataNascita: {
      name: "fisicaDataNascita",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.dataNascita.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    fisicaIndirizzoResidenza: {
      name: "fisicaIndirizzoResidenza",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.indirizzoResidenza.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "google-address",
      suggestionType: "address",
      onSelect: (components, setFieldValue) => {
        setFieldValue(fisicaComuneResidenza.name, components.comune);
        setFieldValue(fisicaProvincia.name, components.provincia);
        setFieldValue(fisicaCAP.name, components.cap);
      },
    },
    fisicaComuneResidenza: {
      name: "fisicaComuneResidenza",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comuneResidenza.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaProvincia: {
      name: "fisicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fisicaCAP: {
      name: "fisicaCAP",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cap.invalid" />
      ),
      type: "input",
    },
    giuridicaRagioneSociale: {
      name: "giuridicaRagioneSociale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.ragioneSociale.label" />
      ),
      placeholder: "Inserisci la ragione sociale",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaCodiceFiscale: {
      name: "giuridicaCodiceFiscale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label" />
      ),
      placeholder: "Inserisci codice fiscale",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.invalid" />
      ),
      uppercase: true,
      type: "input",
    },
    giuridicaPartitaIVA: {
      name: "giuridicaPartitaIVA",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.partitaIVA.label" />
      ),
      placeholder: "Inserisci la partita IVA",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaPartitaIVA2: {
      name: "giuridicaPartitaIVA2",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.partitaIVA.label" />
      ),
      placeholder: "Inserisci la partita IVA",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaPartitaIVAGrupoCheckbox: {
      name: "giuridicaPartitaIVAGrupoCheckbox",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step1.2.giuridicaPartitaIVAGrupoCheckbox.label" />
      ),
      type: "checkbox",
    },
    giuridicaPartitaIVAGrupo: {
      name: "giuridicaPartitaIVAGrupo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVAGrupo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaRappresentanteLegaleName: {
      name: "giuridicaRappresentanteLegaleName",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleName.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaRappresentanteLegaleSurname: {
      name: "giuridicaRappresentanteLegaleSurname",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleSurname.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaProvincia: {
      name: "giuridicaProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: "Inserisci la provincia",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaSedeLegaleComune: {
      name: "giuridicaSedeLegaleComune",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.sedeLegaleComune.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    giuridicaCAP: {
      name: "giuridicaCAP",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cap.invalid" />
      ),
      type: "input",
    },
    giuridicaSedeLegaleIndirizzo: {
      name: "giuridicaSedeLegaleIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.sedeLegaleIndirizzo.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "google-address",
      suggestionType: "address",
      onSelect: (components, setFieldValue) => {
        setFieldValue(giuridicaSedeLegaleComune.name, components.comune);
        setFieldValue(giuridicaProvincia.name, components.provincia);
        setFieldValue(giuridicaCAP.name, components.cap);
      },
    },

    //step 2.1
    dicSosName: {
      name: "dicSosName",
      label: <TranslatedText i18nKey="cases.request_info.fields.name.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosSurname: {
      name: "dicSosSurname",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.surname.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosNatoA: {
      name: "dicSosNatoA",
      label: <TranslatedText i18nKey="cases.request_info.fields.natoA.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosDataNascita: {
      name: "dicSosDataNascita",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.dataNascita.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    dicSosComuneResidenza: {
      name: "dicSosComuneResidenza",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comuneResidenza.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosProvincia: {
      name: "dicSosProvincia",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    qualita: {
      name: "qualita",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.qualita.label" />
      ),
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="common.personRoleType.ContractHolder" />
          ),
          value: PersonRoleType.CONTRACT_HOLDER,
          grid: { xs: 12, md: "3" },
        },
        {
          label: (
            <TranslatedText i18nKey="common.personRoleType.LegalRepresentative" />
          ),
          value: PersonRoleType.LEGAL_REPRESENTATIVE,
          grid: { xs: 12, md: "3" },
        },
        {
          label: <TranslatedText i18nKey="common.personRoleType.Other" />,
          value: PersonRoleType.OTHER,
          grid: { xs: 12, md: "3" },
        },
      ],
    },

    //step 2.1 previous
    dicSosNumeroBolletta: {
      name: "dicSosNumeroBolletta",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosNumeroBolletta" />
      ),
      placeholder: "Inserisci numero",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosDataBolletta: {
      name: "dicSosDataBolletta",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosDataScopertaPerdita" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    dicSosDataScopertaPerdita: {
      name: "dicSosDataScopertaPerdita",
      label: "",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosDataScopertaPerdita" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "date",
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    dicSosMetriCubiPerdita: {
      name: "dicSosMetriCubiPerdita",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosMetriCubiPerdita" />
      ),
      placeholder: "Inserisci valore in m3",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosCausaDanno: {
      name: "dicSosCausaDanno",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosCausaDanno" />
      ),
      placeholder: "Inserisci causa",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosDataRiparazione: {
      name: "dicSosDataRiparazione",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosDataRiparazione" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: "date",
    },
    dicSosLetturaFinePerdita: {
      name: "dicSosLetturaFinePerdita",
      summaryLabel: (
        <TranslatedText i18nKey="cases.request_info.dicSosLetturaFinePerdita" />
      ),
      placeholder: "Inserisci valore in m3",
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    dicSosEstremiDocumento: {
      name: "dicSosEstremiDocumento",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.estremi.documento.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    // step 3
    bollettaRecapitoTipo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'radio',
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoTipo.label" />,
          value: TipoBollettaRecapito.PRE_ESISTENTE,
          grid: { xs: 12 }
        },
      ],
    },
    bollettaRecapitoNuovoIndirizzo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'radio',
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoNuovoIndirizzo.label" />,
          value: TipoBollettaRecapito.NUOVO,
          grid: { xs: 12 }
        },
      ],
    },
    bollettaPuntoDiFurnitura: {
      name: "bollettaPuntoDiFurnitura",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "button",
      title: <TranslatedText i18nKey="common.select" />,
      // className: 'selected',
      summaryView: false,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaDatiIntestatario.name)
          .classList.remove("selected");
        setFieldValue(
          bollettaEsistenteIndirizzo.name,
          `${values.via}, ${values.numeroCivico}`
        );
        setFieldValue(bollettaEsistenteComune.name, values.comune);
        setFieldValue(bollettaEsistenteProvincia.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
      },
    },
    bollettaDatiIntestatario: {
      name: "bollettaDatiIntestatario",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "button",
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add("selected");
        document
          .getElementById(bollettaPuntoDiFurnitura.name)
          .classList.remove("selected");
        setFieldValue(
          bollettaEsistenteIndirizzo.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaIndirizzoResidenza
            : values.giuridicaSedeLegaleIndirizzo
        );
        setFieldValue(
          bollettaEsistenteComune.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaComuneResidenza
            : values.giuridicaSedeLegaleComune
        );
        setFieldValue(
          bollettaEsistenteProvincia.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaProvincia
            : values.giuridicaProvincia
        );
        setFieldValue(
          bollettaEsistenteCap.name,
          values.tipoIntestatario === PersonType.NATURAL
            ? values.fisicaCAP
            : values.giuridicaCAP
        );
      },
    },
    bollettaEsistenteIndirizzo: {
      name: "bollettaEsistenteIndirizzo",
      label: (
        <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      type: "google-address",
      suggestionType: "address",
      onSelect: (components, setFieldValue) => {
        setFieldValue(bollettaEsistenteComune.name, components.comune || "");
        setFieldValue(bollettaEsistenteCap.name, components.cap || "");
        setFieldValue(
          bollettaEsistenteProvincia.name,
          components.provincia || ""
        );
      },
    },
    bollettaEsistenteComune: {
      name: 'bollettaEsistenteComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder" />,
      type: "input",
    },
    bollettaEsistenteCap: {
      name: 'bollettaEsistenteCap',
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input'
    },
    bollettaEsistenteProvincia: {
      name: 'bollettaEsistenteProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input',
    },
    bollettaEsistentePresso: {
      name: 'bollettaEsistentePresso',
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input'
    },
    bollettaEsistenteCellulare: {
      name: 'bollettaEsistenteCellulare',
      label: <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.required" />,
      type: 'input',
    },
    bollettaEsistenteFisso: {
      name: 'bollettaEsistenteFisso',
      label: <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />,
      type: 'input',
    },
    bollettaEsistenteEmail: {
      name: 'bollettaEsistenteEmail',
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.required" />,
      type: 'input',
    },
    bollettaEsistentePec: {
      name: 'bollettaEsistentePec',
      label: <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />,
      type: 'input',
    },
    // New Address
    bollettaNuovoIndirizzo: {
      name: 'bollettaNuovoIndirizzo',
      label: <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      type: 'google-address',
      suggestionType: 'address',
      onSelect: (components, setFieldValue) => {
        setFieldValue(bollettaNuovoComune.name, components.comune || "");
        setFieldValue(bollettaNuovoCap.name, components.cap || "");
        setFieldValue(bollettaNuovoProvincia.name, components.provincia || "");
      },
    },
    bollettaNuovoComune: {
      name: 'bollettaNuovoComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder" />,
      type: 'input'
    },
    bollettaNuovoCap: {
      name: 'bollettaNuovoCap',
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder" />,
      type: 'input'
    },
    bollettaNuovoProvincia: {
      name: 'bollettaNuovoProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input',
    },
    bollettaNuovoPresso: {
      name: 'bollettaNuovoPresso',
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input'
    },
    bollettaNuovoCellulare: {
      name: 'bollettaNuovoCellulare',
      label: <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.required" />,
      type: 'input',
    },
    bollettaNuovoFisso: {
      name: 'bollettaNuovoFisso',
      label: <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />,
      type: 'input',
    },
    bollettaNuovoEmail: {
      name: 'bollettaNuovoEmail',
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'input',
    },
    bollettaNuovoPec: {
      name: 'bollettaNuovoPec',
      label: <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      type: 'input',
    },
    refoundType: {
      name: "refoundType",
      label: "",
      type: "switch-radio",
      options: [
        { label: <TranslatedText i18nKey="cases.denunciaperdite.refoundType.option1" />, value: 'CHEQUE', grid: { xs: 12, md: 12 } },
        {
          label: <TranslatedText i18nKey="cases.denunciaperdite.refoundType.option2" />,
          value: 'DEPOSIT',
          grid: { xs: 12, md: 12 },
        },
      ],
    },
    cognomeNomeDelConto: {
      name: "cognomeNomeDelConto",
      label: <TranslatedText i18nKey="cases.voltura.cognome_del_conto.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.voltura.cognome_del_conto.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    iban: {
      name: 'iban',
      label: <TranslatedText i18nKey="cases.voltura.iban.label"/>,
      labelButton: <TranslatedText i18nKey="cases.voltura.iban.labelButton.validation.text"/>,
      invalidErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.not_supported'/>),
      requiredErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.required'/>),
      modalInfoContent: <TranslatedText i18nKey="cases.voltura.iban.modalInfoContent"/>,
      modalInfoButtonText: <TranslatedText i18nKey="cases.voltura.iban.modalInfoButtonText"/>,
      relatedInfo: [
        {'bankName': 'bankName'},
        {'agency': 'agencia'}
      ],
      type: 'iban',
    },

  },
};

const {
  formField: {
    selezioneContratto,
    comune,
    via,
    tipoIntestatario,
    name,
    surname,
    fisicaCodiceFiscale,
    fisicaNatoA,
    fisicaDataNascita,
    fisicaComuneResidenza,
    fisicaProvincia,
    fisicaCAP,
    fisicaSesso,
    fisicaIndirizzoResidenza,
    giuridicaRagioneSociale,
    giuridicaCodiceFiscale,
    giuridicaPartitaIVA,
    giuridicaPartitaIVA2,
    giuridicaPartitaIVAGrupoCheckbox,
    giuridicaPartitaIVAGrupo,
    giuridicaCAP,
    giuridicaProvincia,
    giuridicaRappresentanteLegaleName,
    giuridicaRappresentanteLegaleSurname,
    giuridicaSedeLegaleComune,
    giuridicaSedeLegaleIndirizzo,
    dicSosName,
    dicSosSurname,
    dicSosNatoA,
    dicSosDataNascita,
    dicSosComuneResidenza,
    dicSosProvincia,
    qualita,
    dicSosNumeroBolletta,
    dicSosDataBolletta,
    dicSosDataScopertaPerdita,
    dicSosMetriCubiPerdita,
    dicSosCausaDanno,
    dicSosDataRiparazione,
    dicSosLetturaFinePerdita,
    dicSosEstremiDocumento,

    //step 3.1
    bollettaRecapitoTipo,
    bollettaRecapitoNuovoIndirizzo,
    bollettaPuntoDiFurnitura,
    bollettaDatiIntestatario,
    bollettaEsistenteIndirizzo,
    bollettaEsistenteComune,
    bollettaEsistenteCap,
    bollettaEsistenteProvincia,
    bollettaEsistentePresso,
    bollettaEsistenteFisso,
    bollettaEsistenteCellulare,
    bollettaEsistenteEmail,
    bollettaEsistentePec,
    bollettaNuovoIndirizzo,
    bollettaNuovoComune,
    bollettaNuovoCap,
    bollettaNuovoProvincia,
    bollettaNuovoPresso,
    bollettaNuovoFisso,
    bollettaNuovoCellulare,
    bollettaNuovoEmail,
    bollettaNuovoPec,
    refoundType,
    cognomeNomeDelConto,
    iban

  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [selezioneContratto.name]: "",
  [comune.name]: "",
  [via.name]: "",

  // step 1.2
  [tipoIntestatario.name]: PersonType.NATURAL,
  [fisicaSesso.name]: PersonSex.M,
  [name.name]: "",
  [surname.name]: "",
  [fisicaCodiceFiscale.name]: "",
  [fisicaNatoA.name]: "",
  [fisicaDataNascita.name]: "",
  [fisicaComuneResidenza.name]: "",
  [fisicaProvincia.name]: "",
  [fisicaCAP.name]: "",
  [fisicaIndirizzoResidenza.name]: "",
  [giuridicaRagioneSociale.name]: "",
  [giuridicaCodiceFiscale.name]: "",
  [giuridicaPartitaIVA.name]: "",
  [giuridicaPartitaIVA2.name]: "",
  [giuridicaPartitaIVAGrupoCheckbox.name]: false,
  [giuridicaPartitaIVAGrupo.name]: "",
  [giuridicaProvincia.name]: "",
  [giuridicaCAP.name]: "",
  [giuridicaRappresentanteLegaleName.name]: "",
  [giuridicaRappresentanteLegaleSurname.name]: "",
  [giuridicaSedeLegaleComune.name]: "",
  [giuridicaSedeLegaleIndirizzo.nome]: "",

  //step 2.1
  [dicSosName.name]: "",
  [dicSosSurname.name]: "",
  [dicSosNatoA.name]: "",
  [dicSosDataNascita.name]: "",
  [dicSosComuneResidenza.name]: "",
  [dicSosProvincia.name]: "",
  [qualita.name]: PersonRoleType.CONTRACT_HOLDER,
  [dicSosNumeroBolletta.name]: "",
  [dicSosDataBolletta.name]: "",
  [dicSosDataScopertaPerdita.name]: "",
  [dicSosMetriCubiPerdita.name]: "",
  [dicSosCausaDanno.name]: "",
  [dicSosDataRiparazione.name]: "",
  [dicSosLetturaFinePerdita.name]: "",
  [dicSosEstremiDocumento.name]: "",

  //step 3.1
  // bollettaRecapitoNuovoIndirizzo needs to be before bollettaRecapitoTipo so that the default value can stay
  [bollettaRecapitoNuovoIndirizzo.name]: '',
  [bollettaRecapitoTipo.name]: TipoBollettaRecapito.PRE_ESISTENTE,
  [bollettaPuntoDiFurnitura.name]: '',
  [bollettaDatiIntestatario.name]: '',
  [bollettaEsistenteIndirizzo.name]: '',
  [bollettaEsistenteComune.name]: '',
  [bollettaEsistenteCap.name]: '',
  [bollettaEsistenteProvincia.name]: '',
  [bollettaEsistentePresso.name]: '',
  [bollettaEsistenteFisso.name]: '',
  [bollettaEsistenteCellulare.name]: '',
  [bollettaEsistenteEmail.name]: '',
  [bollettaEsistentePec.name]: '',
  [bollettaNuovoIndirizzo.name]: '',
  [bollettaNuovoComune.name]: '',
  [bollettaNuovoCap.name]: '',
  [bollettaNuovoProvincia.name]: '',
  [bollettaNuovoPresso.name]: '',
  [bollettaNuovoFisso.name]: '',
  [bollettaNuovoCellulare.name]: '',
  [bollettaNuovoEmail.name]: '',
  [bollettaNuovoPec.name]: '',
  [refoundType.name]: 'CHEQUE',
  [cognomeNomeDelConto.name]: '',
  [iban.name]: '',

};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  const validationFiscalCode = getValidationRule("fiscalCode");
  const validationNumber = getValidationRule('number');
  const validationEmail = getValidationRule('email');
  const validationPhone = getValidationRule('phone');
  const validationFiscalCodeOrVAT = getValidationRule("fiscalCodeOrVAT");


  return [
    Yup.object().shape({
      [selezioneContratto.name]: Yup.string().required(
        selezioneContratto.requiredErrorMsg
      ),
      [comune.name]: Yup.string().required(comune.requiredErrorMsg),
      [via.name]: Yup.string().required(via.requiredErrorMsg),
    }),
    Yup.object().shape({
      [tipoIntestatario.name]: Yup.string().required(tipoIntestatario.requiredErrorMsg),
      [name.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [surname.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [fisicaSesso.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [fisicaCodiceFiscale.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short" />)
          .max(16, <TranslatedText i18nKey="errors.registration.public.fc.long" />)
          .matches(validationFiscalCode, { message: fisicaCodiceFiscale.invalidErrorMsg, })
          .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
      }),
      [fisicaNatoA.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(fisicaNatoA.requiredErrorMsg),
      }),
      [fisicaDataNascita.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(fisicaDataNascita.requiredErrorMsg),
      }),
      [fisicaComuneResidenza.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(fisicaComuneResidenza.requiredErrorMsg),
      }),
      [fisicaProvincia.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true).max(2,<TranslatedText i18nKey="province.length" />)
          .required(fisicaProvincia.requiredErrorMsg),
      }),
      [fisicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.number()
            .typeError(fisicaCAP.invalidErrorMsg)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            )        }),
      // Persona giuridica
      [giuridicaRagioneSociale.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(giuridicaRagioneSociale.requiredErrorMsg),
      }),
      [giuridicaCodiceFiscale.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVA.name], {
        is: (field, giuridicaPartitaIVA) => field === PersonType.LEGAL && !giuridicaPartitaIVA,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaPartitaIVA2.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, giuridicaPartitaIVAGrupoCheckbox) => field === PersonType.LEGAL && giuridicaPartitaIVAGrupoCheckbox ,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
      [giuridicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.number().typeError(giuridicaCAP.invalidErrorMsg).required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          )
        }),
      [giuridicaProvincia.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true).max(2,<TranslatedText i18nKey="province.length" />)
            .required(giuridicaProvincia.requiredErrorMsg),
        }),

      [giuridicaPartitaIVAGrupo.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, checkbox) => field === PersonType.LEGAL && checkbox === true,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),
      [giuridicaRappresentanteLegaleName.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(giuridicaRappresentanteLegaleName.requiredErrorMsg),
        }
        ),
      [giuridicaRappresentanteLegaleSurname.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(giuridicaRappresentanteLegaleSurname.requiredErrorMsg),
        }
        ),
      [giuridicaSedeLegaleComune.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(giuridicaSedeLegaleComune.requiredErrorMsg),
        }
        ),
    }),
    Yup.object().shape({
      [giuridicaPartitaIVA.name]: Yup.string().when([tipoIntestatario.name, giuridicaCodiceFiscale.name], {
        is: (field, giuridicaCodiceFiscale) => field === PersonType.LEGAL && !giuridicaCodiceFiscale,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [qualita.name]: Yup.string().required(qualita.requiredErrorMsg),
      [dicSosName.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosName.requiredErrorMsg),
      [dicSosSurname.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosName.requiredErrorMsg),
      [dicSosNatoA.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosNatoA.requiredErrorMsg),
      [dicSosDataNascita.name]: Yup.string().required(
        dicSosDataNascita.requiredErrorMsg
      ),
      [dicSosComuneResidenza.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosComuneResidenza.requiredErrorMsg),
      [dicSosProvincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosProvincia.requiredErrorMsg),
      [dicSosNumeroBolletta.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosNumeroBolletta.requiredErrorMsg),
      [dicSosDataBolletta.name]: Yup.string().required(
        dicSosDataBolletta.requiredErrorMsg
      ),
      [dicSosDataScopertaPerdita.name]: Yup.string().required(
        dicSosDataScopertaPerdita.requiredErrorMsg
      ),
      [dicSosMetriCubiPerdita.name]: Yup.number()
        .typeError(<TranslatedText i18nKey="cases.common.error.invalidNumber" />)
        .min(1, <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min" />)
        .required(dicSosMetriCubiPerdita.requiredErrorMsg),
      [dicSosCausaDanno.name]: Yup.string().required(
        dicSosCausaDanno.requiredErrorMsg
      ),
      [dicSosDataRiparazione.name]: Yup.string().required(
        dicSosDataRiparazione.requiredErrorMsg
      ),
      [dicSosLetturaFinePerdita.name]: Yup.number()
        .typeError(<TranslatedText i18nKey="cases.common.error.invalidNumber" />)
        .min(1, <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min" />)
        .required(dicSosLetturaFinePerdita.requiredErrorMsg),
      [dicSosEstremiDocumento.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(dicSosEstremiDocumento.requiredErrorMsg),
    }),
    //step 3.1
      Yup.object().shape({
        // Existing Address
        [bollettaEsistenteCellulare.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationPhone, {message: bollettaEsistenteCellulare.invalidErrorMsg,})
              .required(bollettaEsistenteCellulare.requiredErrorMsg)
          }),
        [bollettaEsistenteEmail.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationEmail, {message: bollettaEsistenteEmail.invalidErrorMsg})
              .required(bollettaEsistenteEmail.requiredErrorMsg)
          }),
        [bollettaEsistenteCap.name]:
          Yup.number()
            .when(bollettaRecapitoTipo.name, {
              is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then:Yup.number()
              .typeError(fisicaCAP.invalidErrorMsg)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              )}),
        [bollettaEsistenteComune.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
          }),
        [bollettaEsistenteProvincia.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
          }),
        [bollettaEsistenteFisso.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationPhone, {message: bollettaEsistenteFisso.invalidErrorMsg})
          }),
        [bollettaEsistentePec.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationEmail, {message: bollettaEsistentePec.invalidErrorMsg})
          }),
                // New address
          [bollettaNuovoCellulare.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationPhone, {message: bollettaNuovoCellulare.invalidErrorMsg})
              .required(bollettaNuovoCellulare.requiredErrorMsg)
          }),
        [bollettaNuovoCap.name]:
          Yup.number()
            .when(bollettaRecapitoTipo.name, {
              is: (field) => field === TipoBollettaRecapito.NUOVO,
              then:Yup.number()
          .typeError(fisicaCAP.invalidErrorMsg)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          )}),
        [bollettaNuovoEmail.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationEmail, {message: bollettaNuovoEmail.invalidErrorMsg})
              .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
          }),
        [bollettaNuovoComune.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
          }),
        [bollettaNuovoProvincia.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
          }),
        [bollettaNuovoFisso.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationPhone, {message: bollettaNuovoFisso.invalidErrorMsg})
          }),
        [bollettaNuovoPec.name]: Yup.string()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
              .matches(validationEmail, {message: bollettaNuovoPec.invalidErrorMsg}),
          }),
      }),
      Yup.object().shape({
        [cognomeNomeDelConto.name]: Yup.string().when(
          refoundType.name,
          {
            is: 'DEPOSIT',
            then: Yup.string()
              .trim(<TranslatedText i18nKey="common.empty_characters" />)
              .strict(true)
              .required(cognomeNomeDelConto.requiredErrorMsg),
          }
        ),
        [iban.name]: Yup.string().when(refoundType.name,{
          is: 'DEPOSIT',
          then:  Yup.string()
            .required(iban.requiredErrorMsg)
            .min(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length"/>))
            .max(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length"/>))
            .matches(/[A-Z]/, {
              message: (
                <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_check"/>
              ),
            })
            .matches(/IT[A-Z0-9]{2}\s?/, {
              message: (
                <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_digits"/>
              )
            }),
        }),
      }),
  ];
};
// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    {
      chapter: true,
      title: <TranslatedText i18nKey="cases.denuncia_perdite.step1_1.title" />,
      fields: [
        {
          fieldName: "selezioneContratto",
          grid: {
            xs: 12,
            md: 8,
          },
        },
        {
          fieldName: "comune",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "via",
          grid: {
            xs: 12,
            md: 6,
          },
        },
      ],
    },
    {
      chapter: false,
      title: <TranslatedText i18nKey="cases.denuncia_perdite.step1_2.title" />,
      fields: [
        {
          fieldName: "tipoIntestatario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "name",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "surname",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaNatoA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaDataNascita",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaSesso",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaIndirizzoResidenza",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaComuneResidenza",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaProvincia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCAP",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "giuridicaRagioneSociale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: false,
            }
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA2",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },
        {
          fieldName: "giuridicaPartitaIVAGrupoCheckbox",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
          className: "align-self-center"
        },
        {
          fieldName: "giuridicaPartitaIVAGrupo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },

        {
          fieldName: "giuridicaRappresentanteLegaleName",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaRappresentanteLegaleSurname",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaSedeLegaleIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaSedeLegaleComune",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaProvincia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCAP",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
      ],
    },
    {
      chapter: true,
      title: <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.title1" />,
      description: <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.subtitle1" />,
      fields: [
        {
          fieldName: "dicSosName",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "dicSosSurname",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "dicSosNatoA",
          grid: {
            xs: 12,
            md: 3,
          },
        },
        {
          fieldName: "dicSosDataNascita",
          grid: {
            xs: 12,
            md: 3,
          },
        },
        {
          fieldName: "dicSosComuneResidenza",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "dicSosProvincia",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "qualita",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: <h3 className="contentTitle">
            <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.title2" />
          </h3>,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: <h3 className="contentTitle">
            <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.subtitle2" />
          </h3>,
          grid: {
            xs: 12
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li1" />} />,
          grid: {
            xs: 12,
          },
          className: 'mb-5 ml-20 denuncia-text'
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li2" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "pr-0 ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosNumeroBolletta",
          grid: {
            xs: 5,
            md: 3,
          },
        },
        {
          fieldName: null,
          text: <span style={{ fontSize: "18px" }}>
            <TranslatedText i18nKey="cases.denuncia_perdite.del" />
          </span>,
          grid: {
            xs: 'auto'
          },
          className: "py-2 px-0"
        },
        {
          fieldName: "dicSosDataBolletta",
          grid: {
            xs: 6,
            md: 3,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li3" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosDataScopertaPerdita",
          grid: {
            xs: 12,
            md: 3,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li4" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosMetriCubiPerdita",
          grid: {
            xs: 12,
            md: 3,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li5" />} />,
          grid: {
            xs: 12,
            md: 3
          },
          className: "ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosCausaDanno",
          grid: {
            xs: 12,
            md: 8,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li6" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosDataRiparazione",
          grid: {
            xs: 12,
            md: 5,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.li7" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "ml-20 denuncia-text"
        },
        {
          fieldName: "dicSosLetturaFinePerdita",
          grid: {
            xs: 12,
            md: 3,
          },
        },
        {
          fieldName: "dicSosEstremiDocumento",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: <InfoLabel label={<span style={{ fontSize: "16px" }}>
            <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.p1" />
          </span>} />,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: <InfoLabel label={<span style={{ fontSize: "18px", fontWeight: "bold", fontFamily: `"Source Sans Pro Bold", sans-serif` }}>
            <TranslatedText i18nKey="cases.denuncia_perdite.step2_1.p2" />
          </span>} />,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.p2.li1" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "pb-3 ml-55"
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.p2.li2" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "pb-3 ml-55"
        },
        {
          fieldName: null,
          text: <ListItem text={<TranslatedText i18nKey="cases.denuncia_perdite.step2_1.p2.li3" />} />,
          grid: {
            xs: 12,
            md: 'auto'
          },
          className: "pb-3 ml-55"
        },
      ],
      hooks: {
        pre: (values, setFieldValue) => {
          if (values.tipoIntestatario === PersonType.NATURAL) {
            setFieldValue(dicSosName.name, values.name);
            setFieldValue(dicSosSurname.name, values.surname);
            setFieldValue(dicSosNatoA.name, values.fisicaNatoA);
            setFieldValue(dicSosDataNascita.name, values.fisicaDataNascita);
            setFieldValue(
              dicSosComuneResidenza.name,
              values.fisicaComuneResidenza
            );
            setFieldValue(dicSosProvincia.name, values.fisicaProvincia);
          }
          if (values.tipoIntestatario === PersonType.LEGAL) {
            setFieldValue(dicSosName.name, "");
            setFieldValue(dicSosSurname.name, "");
            setFieldValue(dicSosNatoA.name, "");
            setFieldValue(dicSosDataNascita.name, "");
            setFieldValue(dicSosComuneResidenza.name, "");
            setFieldValue(dicSosProvincia.name, "");
          }
        },
      },
    },
    // step 3.1
         {
          chapter: true,
          chapterName: <TranslatedText i18nKey="cases.allacciamento.step3_1.chapterName"/>,
          title: <TranslatedText i18nKey="cases.allacciamento.step3_1.title"/>,
          hooks: {
            pre: (values, setFieldValue) => {
              setFieldValue(bollettaPuntoDiFurnitura.name, getStandardAddressFormat("cases.address_suggestion.button_1", values.comune, values.via));
              if (values[tipoIntestatario.name] === PersonType.NATURAL) {
                setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[fisicaComuneResidenza.name], values[fisicaProvincia.name], values[fisicaCAP.name], values[fisicaIndirizzoResidenza.name]))
              } else {
                setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[giuridicaSedeLegaleComune.name], values[giuridicaProvincia.name], values[giuridicaCAP.name], values[giuridicaSedeLegaleIndirizzo.name]))
              }
            },
          },
          fields: [
            {
              fieldName: 'bollettaRecapitoTipo',
              grid: {
                md: 6,
                xs: 12
              },
            },
            // New Address
            {
              fieldName: 'bollettaRecapitoNuovoIndirizzo',
              grid: {
                md: 6,
                xs: 12
              },
            },
            // Existing address
            {
              fieldName: 'bollettaPuntoDiFurnitura',
              grid: {
                xs: 12,
                md: 4,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaDatiIntestatario',
              grid: {
                xs: 12,
                md: 4,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: "bollettaEsistenteIndirizzo",
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [
                {
                  if: "bollettaRecapitoTipo",
                  is: TipoBollettaRecapito.PRE_ESISTENTE,
                },
              ],
            },
            {
              fieldName: 'bollettaEsistenteComune',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistenteCap',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistenteProvincia',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistentePresso',
              grid: {
                xs: 12,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistenteCellulare',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistenteFisso',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistenteEmail',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
            },
            {
              fieldName: 'bollettaEsistentePec',
              grid: {
                xs: 12,
                md: 6,
              },
              condition: [{
                if: 'bollettaRecapitoTipo',
                is: TipoBollettaRecapito.PRE_ESISTENTE
              }]
           },
                  {
                    fieldName: 'bollettaNuovoIndirizzo',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoComune',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoCap',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoProvincia',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoPresso',
                    grid: {
                      xs: 12,
                      md: 6
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: null,
                    grid: {
                      xs: 12,
                      md: 6
                    }
                  },
                  {
                    fieldName: 'bollettaNuovoCellulare',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoFisso',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoEmail',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
                  {
                    fieldName: 'bollettaNuovoPec',
                    grid: {
                      xs: 12,
                      md: 6,
                    },
                    condition: [{
                      if: 'bollettaRecapitoTipo',
                      is: TipoBollettaRecapito.NUOVO
                    }]
                  },
          ],
        },
    {
      chapter: true,
      noMandatoryLegend: true,
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.informativa_privacy.chapter_name" />
      ),
      fields: [],
      content: (
        <div>
          <p>
            <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
          </p>
          <p>
            <TranslatedText i18nKey="cases.info.legal2" />
          </p>
        </div>
      ),
    },
    {
      chapter: true,
      noMandatoryLegend: true,
      title: (
        <TranslatedText i18nKey="cases.denunciaperdite.refound.title" />
      ),
      fields: [
        {
          fieldName: 'refoundType',
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: 'cognomeNomeDelConto',
          grid: {
            xs: 12,
            md: 12,
          },
          condition: [{
            if: 'refoundType',
            is: 'DEPOSIT'
          }]
        },
        {
          fieldName: 'iban',
          grid: {
            xs: 12,
            md: 12,
          },
          condition: [{
            if: 'refoundType',
            is: 'DEPOSIT'
          }]
        },
      ],
    },

  ])
}
const translatedMapping = (payload,excludeProperties) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const EXISTING = payload[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE;
   if(!excludeProperties) {
     return {
       accountHolder: {
         personType: payload[tipoIntestatario.name],
         name: NATURAL ? payload[name.name] : payload[giuridicaRappresentanteLegaleName.name],
         surname: NATURAL ? payload[surname.name] : payload[giuridicaRappresentanteLegaleSurname.name],
         ...(!NATURAL && { businessName: payload[giuridicaRagioneSociale.name] }),
         fiscalCode: NATURAL ? payload[fisicaCodiceFiscale.name] : payload[giuridicaCodiceFiscale.name],
         ...(!NATURAL && { vatNumber:payload[giuridicaPartitaIVAGrupoCheckbox.name] === false? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
         ...(NATURAL && { birthPlace: payload[fisicaNatoA.name] }),
         ...(NATURAL && { birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy") }),
         ...(NATURAL && { sex: payload[fisicaSesso.name] }),
         address: {
           city: NATURAL ? payload[fisicaComuneResidenza.name] :
             payload[giuridicaSedeLegaleComune.name],
           postalCode: NATURAL ? payload[fisicaCAP.name] : payload[giuridicaCAP.name],
           province: NATURAL ? payload[fisicaProvincia.name] : payload[giuridicaProvincia.name],
           street: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(",")[0] || "" :
             payload[giuridicaSedeLegaleIndirizzo.name].split(",")[0] || "",
           streetNumber: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(",")[1] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(",")[1] || "",
         },
         vatNumberGroupInfo: {
           enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
           value: payload[giuridicaPartitaIVAGrupo.name]
         },
         contactsInfo: {
           addressRecapito: {
             city: EXISTING ? payload[bollettaEsistenteComune.name] : payload[bollettaNuovoComune.name],
             postalCode: EXISTING ? payload[bollettaEsistenteCap.name] : payload[bollettaNuovoCap.name],
             province: EXISTING ? payload[bollettaEsistenteProvincia.name] : payload[bollettaNuovoProvincia.name],
             street: EXISTING ? payload[fisicaIndirizzoResidenza.name].split(',')[0] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[0] || "",
             streetNumber: EXISTING ? payload[fisicaIndirizzoResidenza.name].split(',')[1] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[1] || "",
             surname: EXISTING ? payload[bollettaEsistentePresso.name] : payload[bollettaNuovoPresso.name]
           },
           email: EXISTING ? payload[bollettaEsistenteEmail.name] : payload[bollettaNuovoEmail.name],
           ...(EXISTING ? payload[bollettaEsistenteFisso.name] && {landlinePhoneNumber: (payload[bollettaEsistenteFisso.name])} : payload[bollettaNuovoFisso.name] && {
             landlinePhoneNumber: (payload[bollettaNuovoFisso.name])
           }),
           mobilePhoneNumber: EXISTING ? payload[bollettaEsistenteCellulare.name] : payload[bollettaNuovoCellulare.name],
           pec: EXISTING ? payload[bollettaEsistentePec.name] : payload[bollettaNuovoPec.name],
         },
       },
       agreement: {
         privacy: true,
         profiling: true,
         marketing: true,
       },
       currentContract: {
         contractId: payload[selezioneContratto.name],
         declaration: {
           undersigned: `${payload[dicSosSurname.name]} ${payload[dicSosName.name]
           }`,
           birthDate: moment(payload[dicSosDataNascita.name]).format("DD/MM/yyyy"),
           birthPlace: payload[dicSosNatoA.name],
           address: {
             city:
               payload[fisicaComuneResidenza.name] ||
               payload[giuridicaSedeLegaleComune.name],
             province:
               payload[fisicaProvincia.name] || payload[giuridicaProvincia.name],
           },
           personRole: payload[qualita.name],
           invoiceIrregularConsumption: payload[dicSosNumeroBolletta.name],
           invoiceIrregularConsumptionDate: moment(
             payload[dicSosDataBolletta.name]
           ).format("DD/MM/yyyy"),
           lossDate: moment(payload[dicSosDataScopertaPerdita.name]).format(
             "DD/MM/yyyy"
           ),
           damageCause: payload[dicSosCausaDanno.name],
           damageFixingDate: moment(payload[dicSosDataRiparazione.name]).format(
             "DD/MM/yyyy"
           ),
           readingAfterFix: payload[dicSosLetturaFinePerdita.name],
         },
         reading: {
           value: Number(payload[dicSosMetriCubiPerdita.name]),
         },
         identityCardCode: payload[dicSosEstremiDocumento.name],
       },
       bankRefound: {
         refoundType: payload[refoundType.name],
         iban: payload[iban.name],
         owner: payload[cognomeNomeDelConto.name]
       },
       draft: false,
       type: CaseForms.DenunciaPerdite,
     };
   }

};
const translatedInverseMapping = (payload, values) => {
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });
  const mapping = {
    "req.accountHolder.personType": tipoIntestatario.name,
    "req.accountHolder.name": values[tipoIntestatario.name] === PersonType.NATURAL ?
      name.name : giuridicaRappresentanteLegaleName.name,
    "req.accountHolder.surname": values[tipoIntestatario.name] === PersonType.NATURAL ?
      surname.name : giuridicaRappresentanteLegaleSurname.name,
    "req.accountHolder.businessName": giuridicaRagioneSociale.name,
    "req.accountHolder.fiscalCode": fisicaCodiceFiscale.name,
    "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,
    "req.accountHolder.birthPlace": fisicaNatoA.name,
    "req.accountHolder.sex": fisicaSesso.name,


    "req.accountHolder.address.city": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaComuneResidenza.name : giuridicaSedeLegaleComune.name,
    "req.accountHolder.address.postalCode": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCAP.name : giuridicaCAP.name,
    "req.accountHolder.address.province": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaProvincia.name : giuridicaProvincia.name,
    "req.accountHolder.address.street": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,
    "req.accountHolder.address.streetNumber": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,


    "req.currentContract.contractId": selezioneContratto.name,

    "req.accountHolder.contactsInfo.addressRecapito.city": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteComune.name : bollettaNuovoComune.name,
    "req.accountHolder.contactsInfo.addressRecapito.postalCode": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteCap.name : bollettaNuovoCap.name,
    "req.accountHolder.contactsInfo.addressRecapito.province": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteProvincia.name : bollettaNuovoProvincia.name,
    "req.accountHolder.contactsInfo.addressRecapito.street": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteIndirizzo.name : bollettaNuovoIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.streetNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteIndirizzo.name : bollettaNuovoIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.surname": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistentePresso.name : bollettaNuovoPresso.name,

    "req.accountHolder.contactsInfo.email": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteEmail.name : bollettaNuovoEmail.name,
    "req.accountHolder.contactsInfo.landlinePhoneNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteFisso.name : bollettaNuovoFisso.name,
    "req.accountHolder.contactsInfo.mobilePhoneNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteCellulare.name : bollettaNuovoCellulare.name,
    "req.accountHolder.contactsInfo.pec": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistentePec.name : bollettaNuovoPec.name,

    "req.currentContract.declaration.undersigned": dicSosName.name,
    "req.currentContract.declaration.birthDate": dicSosDataNascita.name,
    "req.currentContract.declaration.birthPlace": dicSosNatoA.name,
    "req.currentContract.declaration.address.city": fisicaComuneResidenza.name,
    "req.currentContract.declaration.address.province": fisicaProvincia.name,
    "req.currentContract.declaration.personRole": qualita.name,

    "req.currentContract.reading.value": dicSosMetriCubiPerdita.name,
    "req.currentContract.identityCardCode": dicSosEstremiDocumento.name,
    "req.currentContract.declaration.invoiceIrregularConsumption":
      dicSosNumeroBolletta.name,
    "req.currentContract.declaration.invoiceIrregularConsumptionDate":
      dicSosDataBolletta.name,
    "req.currentContract.declaration.lossDate": dicSosDataScopertaPerdita.name,
    "req.currentContract.declaration.damageCause": dicSosCausaDanno.name,
    "req.currentContract.declaration.damageFixingDate":
      dicSosDataRiparazione.name,
    "req.currentContract.declaration.readingAfterFix":
      dicSosLetturaFinePerdita.name,
    "req.bankRefound.refoundType": refoundType.name,
    "req.bankRefound.owner": cognomeNomeDelConto.name ,
    "req.bankRefound.iban":  iban.name
  };
  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};
// Contiene dettagli sul case form
const formDetails = {
  title: <TranslatedText i18nKey="cases.names.LEAK_REPORTING" />,
  description: null,
  summary: true,
  stepper: CaseStepperType.Full,
  autoOpenHelpModal: true,
  helpText: (
    <div className={"content"}>
      <p>
        <TranslatedText i18nKey="cases.denuncia_perdite.help_text" />
      </p>
      <p>
        <TranslatedText i18nKey="cases.tutela_perdite.help_text_3" />
      </p>
      <ul>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li1" />{' '}
          <a className="link email" href={`mailto:fondoperdite@gruppocap.it`}>
            fondoperdite@gruppocap.it
          </a>
        </li>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part" />{' '}
          <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name" /></span>{' '}
          <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part" />
        </li>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax" /> {' '}
          <span className="bold">
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number" />
          </span>
        </li>
      </ul>
      <p><TranslatedText i18nKey="cases.voltura.help_text_2" /></p>
    </div>
  ),
  successText: (
    <>
      <p>
        <TranslatedText i18nKey="cases.complex.success.pdf" />
      </p>
      <ul>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li1" />{' '}
          <a className="link" href={`mailto:fondoperdite@gruppocap.it`}>
            fondoperdite@gruppocap.it
          </a>
        </li>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part" />{' '}
          <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name" /></span>{' '}
          <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part"/>
        </li>
        <li>
          <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax" /> {' '}
          <span className="bold">
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number" />
          </span>
        </li>
      </ul>
      <p><TranslatedText i18nKey="cases.complex.success.pdf_part_1" /></p>
    </>
  ),
};
const mutation = {
  type: CaseMutationType.Complex,
};

const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  const layout = getLayout(privacyLink, privacyCtaLabel);
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};

export default main;
